import { DialogContent, Stack } from "@mui/material";
import { FilterSectionSkeleton } from "@src/appV2/redesign/ShiftDiscovery/Filters/BottomSheet/FilterSectionSkeleton";
import { FilterSectionWrapper } from "@src/appV2/redesign/ShiftDiscovery/Filters/BottomSheet/FilterSectionWrapper";
import { QualificationsFilterButtonGroup } from "@src/appV2/redesign/ShiftDiscovery/Filters/QualificationsFilterButtonGroup";
import { ShiftTimeSlotButtonGroup } from "@src/appV2/redesign/ShiftDiscovery/Filters/ShiftTimeSlotButtonGroup";
import {
  BottomSheet,
  CounterText,
  Divider,
  PageHeaderWrapper,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { useWorkerQualifications } from "@src/appV2/Worker/useWorkerQualifications";
import { Controller, useFormContext } from "react-hook-form";

import { ShiftHistoryFiltersBottomSheetFooter } from "./Footer";
import { type FiltersFormValues } from "./useFiltersForm";

interface ShiftHistoryFiltersBottomSheetProps {
  modalState: UseModalState;
  changedFiltersCount: number;
  resetFilters: () => void;
  cancelFilters: () => void;
  onSubmit: () => void;
}

export function ShiftHistoryFiltersBottomSheet(props: ShiftHistoryFiltersBottomSheetProps) {
  const { modalState, changedFiltersCount, resetFilters, cancelFilters, onSubmit } = props;

  const form = useFormContext<FiltersFormValues>();
  const { data: workerQualifications, isSuccess: workerQualificationsAreLoaded } =
    useWorkerQualifications();

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <ShiftHistoryFiltersBottomSheetFooter
          showClearFormButton={changedFiltersCount > 0}
          onClear={() => {
            resetFilters();
          }}
          onCancel={() => {
            cancelFilters();
            modalState.closeModal();
          }}
          onSubmit={form.handleSubmit(() => {
            onSubmit();
            modalState.closeModal();
          })}
        />
      }
    >
      <DialogContent sx={{ paddingBottom: 12 }}>
        <Stack spacing={8}>
          <PageHeaderWrapper variant="tertiary">
            <CounterText count={changedFiltersCount} suffix="applied">
              <Title variant="h4" component="h4">
                Filters
              </Title>
            </CounterText>
          </PageHeaderWrapper>

          <Controller
            control={form.control}
            name="shiftTimeSlots"
            render={({ field }) => (
              <FilterSectionWrapper sectionTitle="Shift Times">
                <ShiftTimeSlotButtonGroup value={field.value} onChange={field.onChange} />
              </FilterSectionWrapper>
            )}
          />

          <Divider />

          <Controller
            control={form.control}
            name="licenses"
            render={({ field }) => {
              return (
                <FilterSectionWrapper sectionTitle="Shift Roles">
                  {workerQualificationsAreLoaded ? (
                    <QualificationsFilterButtonGroup
                      value={field.value}
                      qualifications={workerQualifications ?? []}
                      onChange={field.onChange}
                    />
                  ) : (
                    <FilterSectionSkeleton />
                  )}
                </FilterSectionWrapper>
              );
            }}
          />
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
